import Image from 'next/image';
import { SVGProps } from 'react';
import { FolderOpenIcon, HandIcon, SparklesIcon } from '@heroicons/react/solid';
import { motion } from 'framer-motion';
import PurpleSwoosh from '../../../assets/purple_swoosh.png';

export const BusinessFeatures = () => (
  <div className="my-12 flex flex-col justify-center lg:flex-row lg:justify-between">
    <div className="bg-dark-blue relative mx-4 mb-4 overflow-hidden rounded-2xl p-8 shadow-xl shadow-black/10 lg:mx-0 lg:mb-0 lg:w-[300px] lg:bg-white">
      <div className="relative z-10">
        <motion.div
          className="text-brand-secondary-new mb-8 inline-block rounded-full bg-[#F8EBFB] p-6 lg:mb-20"
          initial={{ opacity: 0, y: 100, scale: 1 }}
          whileInView={{
            opacity: 1,
            scale: 1,
            y: 0,
            transition: { duration: 0.5, delay: 0.1 },
          }}
          viewport={{ once: true }}
        >
          <SparklesIcon className="w-8" />
        </motion.div>

        <motion.h3
          className="mb-3 text-[2rem] text-white lg:text-black"
          initial={{ opacity: 0, y: 100, scale: 1 }}
          whileInView={{
            opacity: 1,
            scale: 1,
            y: 0,
            transition: { duration: 0.5, delay: 0.1 },
          }}
          viewport={{ once: true }}
        >
          Flexible <span className="font-normal">monthly cover</span>
        </motion.h3>
        <motion.p
          className="font-medium text-white lg:text-black"
          initial={{ opacity: 0, y: 100, scale: 1 }}
          whileInView={{
            opacity: 1,
            scale: 1,
            y: 0,
            transition: { duration: 0.5, delay: 0.1 },
          }}
          viewport={{ once: true }}
        >
          Monthly subscription that can be updated and cancelled at any time.
          True monthly policy with no financing cost added on top.
        </motion.p>
      </div>

      <Image
        src={PurpleSwoosh}
        alt="swoosh"
        className="absolute -top-1/2 -left-1/2 z-0"
      />
    </div>

    <div className="bg-dark-blue relative mx-4 mb-4 overflow-hidden rounded-2xl p-8 shadow-xl shadow-black/10 lg:mx-0 lg:mb-0 lg:w-[300px] lg:bg-white">
      <div className="relative z-10">
        <motion.div
          className="text-brand-secondary-new mb-8 inline-block rounded-full bg-[#F8EBFB] p-6 lg:mb-20"
          initial={{ opacity: 0, y: 100, scale: 1 }}
          whileInView={{
            opacity: 1,
            scale: 1,
            y: 0,
            transition: { duration: 0.5, delay: 0.2 },
          }}
          viewport={{ once: true }}
        >
          <HandIcon className="w-8" />
        </motion.div>

        <motion.h3
          className="mb-3 text-[2rem] text-white lg:text-black"
          initial={{ opacity: 0, y: 100, scale: 1 }}
          whileInView={{
            opacity: 1,
            scale: 1,
            y: 0,
            transition: { duration: 0.5, delay: 0.2 },
          }}
          viewport={{ once: true }}
        >
          Pause and re-set <span className="font-normal">as and when</span>
        </motion.h3>
        <motion.p
          className="font-medium text-white lg:text-black"
          initial={{ opacity: 0, y: 100, scale: 1 }}
          whileInView={{
            opacity: 1,
            scale: 1,
            y: 0,
            transition: { duration: 0.5, delay: 0.2 },
          }}
          viewport={{ once: true }}
        >
          If you are not working, pause your cover to minimise premium cost,
          while ensuring your previous projects when you were actively on cover
          remain protected.
        </motion.p>
      </div>

      <Image
        src={PurpleSwoosh}
        alt="swoosh"
        className="absolute -top-1/2 -left-1/2 z-0"
      />
    </div>

    <div className="bg-dark-blue relative mx-4 mb-4 overflow-hidden rounded-2xl p-8 shadow-xl shadow-black/10 lg:mx-0 lg:mb-0 lg:w-[300px] lg:bg-white">
      <div className="relative z-10">
        <motion.div
          className="text-brand-secondary-new mb-8 inline-block rounded-full bg-[#F8EBFB] p-6 lg:mb-20"
          initial={{ opacity: 0, y: 100, scale: 1 }}
          whileInView={{
            opacity: 1,
            scale: 1,
            y: 0,
            transition: { duration: 0.5, delay: 0.3 },
          }}
          viewport={{ once: true }}
        >
          <FolderOpenIcon className="w-8" />
        </motion.div>

        <motion.h3
          className="mb-3 text-[2rem] text-white lg:text-black"
          initial={{ opacity: 0, y: 100, scale: 1 }}
          whileInView={{
            opacity: 1,
            scale: 1,
            y: 0,
            transition: { duration: 0.5, delay: 0.3 },
          }}
          viewport={{ once: true }}
        >
          Project specific <span className="font-normal">insurance</span>
        </motion.h3>
        <motion.p
          className="font-medium text-white lg:text-black"
          initial={{ opacity: 0, y: 100, scale: 1 }}
          whileInView={{
            opacity: 1,
            scale: 1,
            y: 0,
            transition: { duration: 0.5, delay: 0.3 },
          }}
          viewport={{ once: true }}
        >
          Only work for one specific contract that lasts for a short time
          period? Use our project specific contract insurance to cover your
          project on a one-off basis.
        </motion.p>
      </div>

      <Image
        src={PurpleSwoosh}
        alt="swoosh"
        className="absolute -top-1/2 -left-1/2 z-0"
      />
    </div>

    <div className="bg-dark-blue relative mx-4 mb-4 overflow-hidden rounded-2xl p-8 shadow-xl shadow-black/10 lg:mx-0 lg:mb-0 lg:w-[300px] lg:bg-white">
      <div className="relative z-10">
        <motion.div
          className="text-brand-secondary-new mb-8 inline-block rounded-full bg-[#F8EBFB] p-6 lg:mb-20"
          initial={{ opacity: 0, y: 100, scale: 1 }}
          whileInView={{
            opacity: 1,
            scale: 1,
            y: 0,
            transition: { duration: 0.5, delay: 0.4 },
          }}
          viewport={{ once: true }}
        >
          <AirplaneIcon className="text-brand-secondary-new w-8" />
        </motion.div>

        <motion.h3
          className="mb-3 text-[2rem] text-white lg:text-black"
          initial={{ opacity: 0, y: 100, scale: 1 }}
          whileInView={{
            opacity: 1,
            scale: 1,
            y: 0,
            transition: { duration: 0.5, delay: 0.4 },
          }}
          viewport={{ once: true }}
        >
          Global <span className="font-normal">client coverage</span>
        </motion.h3>
        <motion.p
          className="font-medium text-white lg:text-black"
          initial={{ opacity: 0, y: 100, scale: 1 }}
          whileInView={{
            opacity: 1,
            scale: 1,
            y: 0,
            transition: { duration: 0.5, delay: 0.4 },
          }}
          viewport={{ once: true }}
        >
          Traditional insurance typically limits your client base to your local
          country. Our insurance allows you to work with a portfolio of clients
          anywhere in the world. 
        </motion.p>
      </div>

      <Image
        src={PurpleSwoosh}
        alt="swoosh"
        className="absolute -top-1/2 -left-1/2 z-0"
      />
    </div>
  </div>
);

const AirplaneIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M32.5001 2.5C31.8453 2.50403 31.1977 2.63727 30.5945 2.8921C29.9913 3.14693 29.4444 3.51833 28.9851 3.985L23.2826 9.6875L8.90757 7.11C8.71332 7.07347 8.51323 7.08269 8.32316 7.13693C8.13309 7.19117 7.95828 7.28895 7.81257 7.4225L4.29757 11.015C3.73257 11.6125 3.99757 12.76 4.76507 13.0475L16.0951 16.875L10.3876 22.5775L8.04507 22.11C7.84469 22.0834 7.64085 22.1048 7.45043 22.1727C7.26001 22.2405 7.08849 22.3527 6.95007 22.5L3.35757 26.015C2.79257 26.6125 3.05757 27.76 3.82507 28.0475L9.53007 30.47L11.9501 36.17C12.2376 36.9425 13.3851 37.205 13.9826 36.64L17.5001 33.05C17.6474 32.9116 17.7596 32.7401 17.8274 32.5496C17.8952 32.3592 17.9167 32.1554 17.8901 31.955L17.4226 29.69L23.1251 23.985L26.9526 35.235C27.2176 36.0625 28.4726 36.3425 29.0626 35.7025L32.5776 32.11C32.7249 31.9716 32.8371 31.8001 32.9049 31.6096C32.9727 31.4192 32.9942 31.2154 32.9676 31.015L30.3926 16.64L36.0176 11.015C36.9488 10.0822 37.4719 8.81805 37.4719 7.5C37.4719 6.18195 36.9488 4.91776 36.0176 3.985C35.5579 3.51804 35.0106 3.14647 34.4069 2.89163C33.8033 2.63679 33.1553 2.5037 32.5001 2.5Z"
      fill="currentColor"
    />
  </svg>
);
